exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ColorProfileModal-module__modal-content___1zQgk{display:grid;gap:.5rem}.ColorProfileModal-module__modal-content___1zQgk .ColorProfileModal-module__colors-wrapper___2K9Cj{aspect-ratio:1/1;position:relative}", ""]);

// exports
exports.locals = {
	"modal-content": "ColorProfileModal-module__modal-content___1zQgk",
	"colors-wrapper": "ColorProfileModal-module__colors-wrapper___2K9Cj"
};